// extracted by mini-css-extract-plugin
export default {"container":"_3VQJOFqHBPDyD0wkyu4y-6","promoText":"qW2pAIRngp_1exz6f4DN_","feedback":"_3hyeKG-KfdcuzOwvCvwmc8","text":"_13jhN6AIlvwyWvCUUchgkv"};